import {
  ListFundingsRequest,
  ListFundingsResponse,
} from '@cbinsights/fundingservice/fundingservice';
import { UseQueryResult, useQuery } from 'react-query';
import { getListFundingDrafts } from '../api/ListFundingDrafts';

type ListFundingDraftsType = 'ListFundingDrafts';
type GetFundingNotesType = 'GetFundingNotes';
type GetDraftersType = 'GetDrafters';
type GetFundingHistoryResponse = 'GetFundingHistoryResponse';
type GetAllRoundValuesType = 'GetAllRoundValues';
type GetAllInvestorCategoryValuesType = 'GetAllInvestorCategoryValues';
type ListFundingDraftSourceType = 'ListFundingDraftSourceType';
export type FundingServiceKeys =
  | ListFundingDraftsType
  | GetFundingNotesType
  | GetDraftersType
  | GetFundingHistoryResponse
  | GetAllInvestorCategoryValuesType
  | GetAllRoundValuesType
  | ListFundingDraftSourceType;

export const useListFundingDraftQuery = (
  params: ListFundingsRequest,
  enabled = false
): UseQueryResult<ListFundingsResponse, Error> =>
  useQuery<
    ListFundingsResponse,
    Error,
    ListFundingsResponse,
    [FundingServiceKeys, ListFundingsRequest]
  >(['ListFundingDrafts', params], () => getListFundingDrafts(params), {
    notifyOnChangeProps: ['data', 'isFetching', 'isFetched'],
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    enabled,
  });
